import React, { useState, useEffect } from "react";
import Footer from "../../components/Footer/Footer";
import Header from "../../components/Header/Header";
import Logout from "./Logout";
import Sidebar from "./Sidebar";
import "../../assets/css/my-order-detail.css";
import { orderimg1 } from "../../constants";
import AuthHeader from "../../components/AuthHeader/AuthHeader";

const MyorderDetail = () => {
	return (
		<>
			<AuthHeader />
			{/* My adresses starts here */}
			<section className="my-profile">
				<div className="container">
					<div className="row">
						<div className="col-lg-3">
							<Sidebar />
						</div>
						<div className="col-lg-9">
							<Logout />
							{/* return payment starts here */}
							<div className="order-request-wrapper">
								<div className="order-heading-wrapper">
									<h3>My Orders Details</h3>
								</div>
								<div className="order-detail-wrapper">
									<div className="order-no-wrapper">
										<h5>Order No # 123456789</h5>
										<h6>Date : 10/10/22</h6>
									</div>
									<div className="order-cards-wrapper">
										<div className="card-heading-wrapper">
											<h5>Products</h5>
										</div>
										<div className="cards-wrapper">
											<div className="order-card-wrapper">
												<div className="order-img-wrapper">
													<figure>
														<img src={orderimg1} className="img-fluid" alt="" />
													</figure>
												</div>
												<div className="order-content-wrapper">
													<div className="content-heading-wrapper">
														<h6>Sweet Black Shirt</h6>
														<span>Quantity 2</span>
													</div>
													<div className="order-size-wrapper">
														<span className="size">Size L</span>
														<h5 className="price">RS : $22.00</h5>
													</div>
													<a href="/refund-order" className="btn">
														Refund
													</a>
												</div>
											</div>
											<div className="order-card-wrapper">
												<div className="order-img-wrapper">
													<figure>
														<img src={orderimg1} className="img-fluid" alt="" />
													</figure>
												</div>
												<div className="order-content-wrapper">
													<div className="content-heading-wrapper">
														<h6>Sweet Black Shirt</h6>
														<span>Quantity 2</span>
													</div>
													<div className="order-size-wrapper">
														<span className="size">Size L</span>
														<h5 className="price">RS : $22.00</h5>
													</div>
													<a href="#" className="btn">
														Refund
													</a>
												</div>
											</div>
										</div>
									</div>
									<div className="shipping-address-wrapper">
										<div className="heading-wrapper">
											<h5>Shipment Address</h5>
										</div>
										<div className="shipping-lists-wrapper">
											<div className="single-ship-wrapper">
												<ul>
													<li>
														<span className="property">Country:</span>
														<span className="value">United States</span>
													</li>
													<li>
														<span className="property">Address: </span>
														<span className="value">
															10515 Fox Ave Fairdale, Kentucky(KY), 40118
														</span>
													</li>
													<li>
														<span className="property">State:</span>
														<span className="value">Texas</span>
													</li>
												</ul>
											</div>
											<div className="single-ship-wrapper">
												<ul>
													<li>
														<span className="property">Phone:</span>
														<span className="value">+44-123-456-789</span>
													</li>
												</ul>
											</div>
										</div>
									</div>
									<div className="invoice-wrapper">
										<div className="invoice-heading-wrapper">
											<h5>Invoice</h5>
										</div>
										<div className="invoice-list-wrapper">
											<ul>
												<li>
													<span className="property">Item Total Price</span>
													<span className="value">$ 231.00</span>
												</li>
												<li>
													<span className="property">Delivery Charges</span>
													<span className="value">$ 231.00</span>
												</li>
												<li>
													<span className="property">Promo</span>
													<span className="value">- $ 10.00</span>
												</li>
											</ul>
										</div>
										<div className="total-price-wrapper">
											<ul>
												<li>
													<span className="property">Total Price :</span>
													<span className="value">$ 12.00</span>
												</li>
											</ul>
										</div>
									</div>
									<div className="back-btn-wrapper">
										<a href="#" className="btn">
											Back
										</a>
									</div>
								</div>
							</div>
							{/* return payment ends here */}
						</div>
					</div>
				</div>
			</section>
			{/* My adresses ends here */}
			<Footer />
		</>
	);
};

export default MyorderDetail;
